import { render, staticRenderFns } from "./addorupdatebanner.vue?vue&type=template&id=10dea11a&scoped=true"
import script from "./addorupdatebanner.vue?vue&type=script&lang=js"
export * from "./addorupdatebanner.vue?vue&type=script&lang=js"
import style0 from "./addorupdatebanner.vue?vue&type=style&index=0&id=10dea11a&prod&lang=css"
import style1 from "./addorupdatebanner.vue?vue&type=style&index=1&id=10dea11a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dea11a",
  null
  
)

export default component.exports